<section class="container h-100">
  <div class="card w-100 container">
    <div class="card-body">
      <div>
        <div *ngIf="(alertStatus$ | async) && (alertStatus$ | async) != null"  class="alert alert-success d-flex align-items-center text-primary-emphasis bg-primary-subtle" role="alert">
          <svg style="width: 16px; height: 16px;" xmlns="http://www.w3.org/2000/svg" class=" flex-shrink-0 me-2 text" viewBox="0 0 16 16" role="img" aria-label="Warning:">
            <path fill="#198754" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
          </svg>
          <div> Registro existoso </div>
        </div>
        <div *ngIf="!(alertStatus$ | async) && (alertStatus$ | async) != null" class="alert alert-danger d-flex align-items-center" role="alert">
          <svg style="width: 16px; height: 16px;" xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0 me-2 text" viewBox="0 0 16 16" role="img" aria-label="Warning:">
            <path fill="#dc3545" d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
          </svg>
          <div>Registro rechazado
            <br>
            <div *ngFor="let col of (this.dataSource$.asObservable() | async); let index=index">
              <span *ngIf="col.errors?.length > 0">([ROW]: {{index}}) {{col.errors}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col">
          <h5 class="m-0">Anualacion de extracto Bancario </h5>
        </div>
        <div class="col-2 d-flex flex-row justify-content-center">
          <ng-container>
            <button (click)="inputAddCsv.click()" #btnAddCsv name="btnAddCsv" class="btn btn-primary" role="button">
              <span class="mr-1">Agregar .csv</span>
              <i class="fa fa-plus"></i>
            </button>
            <span> </span>
            <button (click)="this.downloadCsvFormato()" #btntemplareCsv name="btntemplareCsv" class="btn btn-warning" role="button">
              <i class="fas fa-file-csv  fa-2x"></i>
              Descarga Plantilla
            </button>
            <input hidden (change)="this.onLoadCsv($event)" accept=".csv" #inputAddCsv type="file" name="inputAddCsv" >
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="(this.dataSource$| async) as response">
    <!-- Each Observable Array to options Columns -->
    <ngx-datatable class="bootstrap" [columnMode]="'force'" [rowHeight]="60" [headerHeight]="60"
                   [footerHeight]="0" [rows]="(response)" [columns]="columns"
                    [scrollbarH]="true"  >
      <ngx-datatable-column  [minWidth]="100" [canAutoResize]="true" [resizeable]="false" [draggable]="false" [sortable]="false"  headerClass="center" [name]="''" [prop]="'partNumber'">
        <ng-template let-column="column" ngx-datatable-header-template>{{ column.name }} </ng-template>
        <ng-template let let-row="row" let-value="value" let-rowIndex="rowIndex" ngx-datatable-cell-template>
          [ROW]: {{rowIndex}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column *ngFor="let column of columns" [minWidth]="100" [canAutoResize]="true" [resizeable]="false" [draggable]="false" [sortable]="false"  headerClass="center" [name]="column.name" [prop]="column.prop">
        <ng-template let-column="column" ngx-datatable-header-template>{{ column.name }} </ng-template>
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>{{ value }}</ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column  [width]="null"  [canAutoResize]="true" [resizeable]="true" [draggable]="false"
                             [sortable]="false"  headerClass="center" [name]="'Observacion'" [prop]="'observacion'" [flexGrow]="1" [style]="{'overflow':'visible', 'white-space': 'normal'}">
        <ng-template let-column="column" ngx-datatable-header-template>{{ column.name }} </ng-template>
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>{{ value[0] }}</ng-template>
      </ngx-datatable-column>

      <!-- Column Actions buttons -->
      <ngx-datatable-column  [minWidth]="100" [canAutoResize]="true" [resizeable]="false" [draggable]="false"
                             [sortable]="false"  headerClass="center" [name]="'Status'" [prop]="'estado'">
        <ng-template let-column="column" ngx-datatable-header-template>{{ column.name }} </ng-template>
<!--        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>{{ value }}</ng-template>-->
        <ng-template let let-row="row" let-value="value" ngx-datatable-cell-template>
          <span *ngIf="value === 'OK'" class="badge text-bg-success">Aceptado</span>
          <span *ngIf="value === 'ERROR'"class="badge text-bg-danger">Error en linea</span>
          <span *ngIf="!value"class="badge text-bg-primary">Sin validar</span>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
    <div class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="this.submit(this.dataSource$.value)">Enviar</button>
    </div>
  </ng-container>
</section>

